<template>
	<div class="bottom-description">
		<div class="left">
			<div class="avatar-container">
				<img src="../../assets/mascotte/mascotte_smile-s.svg" alt="" />
			</div>
			<div class="text-container">
				<p class="montserra-r fs-1">
					{{ peopleText }}
				</p>
			</div>
		</div>
		<div class="right">
			<button class="share" @click="toggleMenu">
				<img src="../../assets/icons/share-icon.svg" alt="" />
			</button>
			<sound-button class="sound" />
		</div>
	</div>
</template>
<style lang="scss" scoped>
	.bottom-description {
		display: flex;
		flex-direction: row;
		justify-content: space-between;
		align-items: center;
		padding: 1rem 0;
		padding-left: 4rem;
		box-sizing: border-box;
		.right,
		.left {
			height: 100%;
		}
		button {
			cursor: pointer;
		}
		.left {
			display: flex;
			flex-direction: row;
			justify-content: space-between;
			align-items: center;
			.avatar-container {
				height: 8rem;
				min-width: 8rem;
				overflow: hidden;
				border-radius: 50%;
				background-color: #d8d8d8;

				display: flex;
				justify-content: flex-end;
				align-items: flex-end;
				img {
					height: 95%;
				}
			}
			.text-container {
				margin-left: 2rem;
				padding: 1.5rem 1rem;
				box-sizing: border-box;

				border: 2px solid #bbb;
				border-radius: 16px;

				position: relative;

				&::before {
					position: absolute;
					content: ' ';
					top: 15%;
					right: 100%;

					width: 0;
					height: 0;
					border-top: 10px solid transparent;
					border-bottom: 10px solid transparent;

					border-right: 10px solid #bbb;
				}
			}
		}

		.right {
			margin-left: 2rem;
			display: flex;
			flex-direction: column;
			justify-content: flex-end;
			button {
				padding: 0;
				height: 2.5rem;
				&:first-child {
					margin-bottom: 1.5rem;
				}
				img {
					height: 100%;
					will-change: transform;
					transition: transform 0.3s ease;
				}
				&:hover {
					img {
						transform: scale(1.4);
					}
				}
			}
		}
	}
</style>
<script>
	import {mapActions, mapState} from 'vuex';
	import SoundButton from './sound-button.vue';
	export default {
		components: {
			SoundButton,
		},
		computed: {
			...mapState(['content', 'currentZoom', 'selectedEntity']),
			peopleText() {
				if (this.selectedEntity === null)
					return 'Séléctionnez une entité pour voir ses informationsVous vous trouvez sur le niveau 1 du microscope. Vous pouvez voir les différentes entités de GTA supports avec les données propres à chacune.';
				switch (this.currentZoom) {
					case 5:
						return 'Vous vous trouvez sur le niveau 1 du microscope. Vous pouvez voir les différentes entités de GTA supports avec les informations propres à chacune. ';
					case 10:
						return 'Vous vous trouvez à présent sur le niveau 2 du microscope. Vous pouvez voir les différentes services  proposés par les entités en cliquant sur les bulles.';
					case 100:
						return 'Vous vous trouvez à présent sur le niveau 3 du microscope. Vous pouvez voir les différentes services  proposés par les entités en cliquant sur les bulles.';
					default:
						return 'Séléctionnez une entité pour voir ses informationsVous vous trouvez sur le niveau 1 du microscope. Vous pouvez voir les différentes entités de GTA supports avec les données propres à chacune.';
				}
			},
		},
		methods: {
			...mapActions(['toggleMenu']),
		},
	};
</script>
